import { app, db } from './firebase';
import {
  doc,
  setDoc,
  getDoc,
  writeBatch,
  serverTimestamp,
} from 'firebase/firestore';

const saveInterviewSettings = async (meetingId, settings) => {
  try {
    if (!meetingId) {
      console.error("Cannot save settings: No meeting ID provided");
      return false;
    }

    const roomRef = doc(db, 'rooms', meetingId);

    await setDoc(roomRef, {
      lastUpdated: serverTimestamp(),
      settings: settings
    }, { merge: true });

    return true;
  } catch (error) {
    console.error('Error saving interview settings:', error);
    return false;
  }
};

const updateCandidateStatus = async (orgId, meetingId, status) => {
  try {
    if (!orgId || !meetingId || !status) {
      return false;
    }

    const interviewRef = doc(db, 'organizations', orgId, 'interviews', meetingId);
    const interviewDoc = await getDoc(interviewRef);

    if (!interviewDoc.exists()) {
      return false;
    }

    const interviewData = interviewDoc.data();
    const { jobListingId, applicantId } = interviewData;

    // Step 2: Update documents in batch
    const batch = writeBatch(db);

    // Always update the interview document
    batch.set(interviewRef, {
      candidateStatus: status
    }, { merge: true });

    // Only update the applicant document if both jobListingId and applicantId exist
    if (jobListingId && applicantId) {
      const applicantRef = doc(db, 'organizations', orgId, 'jobListings', jobListingId, 'applicants', applicantId);
      batch.set(applicantRef, {
        applicationStatus: status
      }, { merge: true });
    }

    // Commit the batch
    await batch.commit();

    return true;

  } catch (error) {
    return false;
  }
};

const saveInterviewerFeedback = async (meetingId, hiringDecision, interviewerFeedback) => {
  try {
    if (!meetingId || !hiringDecision) {
      console.error("Missing required fields for saving feedback");
      return false;
    }

    const interviewRef = doc(db, 'reports', meetingId);

    await setDoc(interviewRef, {
      hiringDecision: hiringDecision,
      interviewerFeedback: interviewerFeedback
    }, { merge: true });

    return true;

  } catch (error) {
    console.error('Error saving interviewer feedback:', error);
    return false;
  }
};

export { saveInterviewSettings, updateCandidateStatus, saveInterviewerFeedback };